export default __webpack_public_path__ + "static/img3-0389872e0d9455f82dc153b8c162f57b.jpg";